
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58 58"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"29","cy":"29","r":"29","fill-opacity":".12"}}),_c('path',{attrs:{"d":"M41.008 19.524c-.041-2.232-1.495-4.229-4.107-5.632-2.258-1.21-5.222-1.883-8.346-1.892-3.122-.007-6.089.647-8.353 1.846-2.653 1.405-4.12 3.424-4.139 5.69v.012l-.005 1.559c-.001.718.556 1.3 1.245 1.302l4.927.015c.69.002 1.25-.578 1.251-1.296l.004-1.56c.001-.717 1.254-2.771 5.059-2.761 3.804.01 5.047 2.024 5.045 2.742l-.005 1.559c-.002.717.556 1.3 1.244 1.302l4.928.015c.688.002 1.249-.578 1.25-1.296l.002-1.605zm-23.324 4.717h5.647v5.882h-5.647zm8.026 0h5.647v5.882H25.71zm8.024 0h5.648v5.882h-5.648zm-16.05 8.176h5.647v5.882h-5.647zm8.026 0h5.647v5.882H25.71zm8.024 0h5.648v5.882h-5.648zm-16.05 8.176h5.647v5.881h-5.647zm8.026 0h5.647v5.881H25.71zm8.024 0h5.648v5.881h-5.648z","fill-rule":"nonzero"}})])])
          )
        }
      }
    